import React, { useState } from 'react';
import { completedProjects } from '../mock';
import { Button } from './ui/button';

const Projects = () => {
  const [visibleCount, setVisibleCount] = useState(6);

  const loadMore = () => {
    setVisibleCount((prev) => Math.min(prev + 6, completedProjects.length));
  };

  return (
    <section id="projects" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Our Projects</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4">
            Our <span className="text-orange-600">Completed Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our portfolio of beautifully crafted homes that showcase our commitment to quality and excellence
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {completedProjects.slice(0, visibleCount).map((project) => (
            <div
              key={project.id}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
              </div>

              {/* Hover Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {/*View Project Details*/}
                </p>
              </div>
            </div>
          ))}
        </div>

        {visibleCount < completedProjects.length && (
          <div className="text-center mt-12">
            <Button
              onClick={loadMore}
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white"
            >
              View More Projects
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;